import React, { useEffect, useState } from "react";
import Styles from "./BankingSearch.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchSearchBanking,
  fetchAllBankingListings,
  setActiveListingId,
  clearMatchmakingData,
  fetchMatchmakingResults,
} from "../../../Redux/Slices/bankingSlice";
import ViewInjectDrawal from "../../Modals/Banking/ViewInjectDrawal/ViewInjectDrawal";
import { ReactComponent as BackIcon } from "../../../assets/images/backIcon.svg";
import { ReactComponent as User } from "../../../assets/images/userplus.svg";
import { ReactComponent as Download } from "../../../assets/images/downloadFile.svg";
import ConnectListingModal from "../../Modals/Banking/ConnectListingModal/ConnectListingModal";
import { Skeleton } from "@mui/material";
import {
  downloadListing,
  getDocumentUrlByLedgerId,
} from "../../../Services/ApiCalling/banking";
import PreviewModal from "../../../commons/PreviewModal/PreviewModal";
import { SuccessMessage } from "../../../commons/Toast/ErrorMessage";
import BankingListingModal from "../../Modals/BankingListingModal/BankingListingModal";
import NoDataPage from "../../Banking/NoDataPage/NoDataPage";
// import useAutoApprovalHandler from "../../../hooks/useAutoApprovalHandler";

const BankingSearch = () => {
  // useAutoApprovalHandler();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [viewDetails, setViewDetails] = useState(false);
  const [connect, setConnect] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [highlightedId, setHighlightedId] = useState(null);
  const bankingSeacrh = useSelector((state) => state?.bankingSlice || {});
  const allListingsSeacrh = bankingSeacrh.allListings || [];
  const [selectedListing, setSelectedListing] = useState(null);
  const loading = bankingSeacrh.loading;
  const [previewFileName, setPreviewFileName] = useState(null);

  const skeletonRows = 7;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const idFromUrl = urlParams.get("id");

    if (idFromUrl) {
      setHighlightedId(parseInt(idFromUrl));
    }

    dispatch(fetchSearchBanking({ current: true }));
  }, [dispatch]);

  const handleOpenView = (listing) => {
    setSelectedListing(listing);
    setViewDetails(true);
  };

  const handleCloseView = () => {
    setViewDetails(false);
  };

  const handleOpenConnect = (listing) => {
    setSelectedListing(listing);
    setConnect(true);
  };
  const handleCloseConnect = () => {
    setConnect(false);
  };

  const handleConnectSubmitSuccess = () => {
    setConnect(false);
    setSelectedListing(null);
    dispatch(fetchSearchBanking({ current: true }));
  };

  const handleViewTermsDocument = async (termsDocumentId) => {
    if (!termsDocumentId || termsDocumentId === 0) {
      console.warn("No terms document ID available");
      return;
    }

    try {
      const response = await getDocumentUrlByLedgerId(termsDocumentId);
      const url = response?.data || response;

      // Extract filename from response if available
      const fileName =
        response?.filename ||
        response?.data?.filename ||
        `terms_and_conditions_${termsDocumentId}.pdf`;

      if (url) {
        setPreviewFileUrl(url);
        setPreviewFileName(fileName);
        setPreviewModal(true);
      } else {
        console.error("No URL found for terms document");
      }
    } catch (error) {
      console.error("Error viewing terms document:", error);
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
    setPreviewFileName(null);
  };

  const handleBackClick = async () => {
    try {
      const listingsResult = await dispatch(fetchAllBankingListings());

      dispatch(clearMatchmakingData());

      const listings = listingsResult.payload || [];

      const firstActiveListing =
        listings.find(
          (listing) =>
            listing.status === "ACTIVE" || listing.status === "active",
        ) || listings[0];

      if (firstActiveListing) {
        dispatch(setActiveListingId(firstActiveListing.id));

        await dispatch(
          fetchMatchmakingResults({
            id: firstActiveListing.id,
            statusFilter: null,
          }),
        );

        navigate(`/banking`);
      } else {
        dispatch(setActiveListingId(null));
        navigate(`/banking`);
      }
    } catch (error) {
      window.location.href = "/banking";
    }
  };

  const preparePrefilledData = (data) => {
    if (!data) {
      return {
        injectionSlots: [[]],
        drawalSlots: [[]],
        bankingFactor: "",
        settlementRate: "DAM+",
        comments: "",
        expiryDate: "",
        expiryTime: "",
        termsExpiryDate: "",
        termsExpiryTime: "",
        activeType: "GNA",
      };
    }

    const splitDateTime = (dt) => {
      if (!dt) return { date: "", time: "" };
      const [datePart, timePart] = dt.split(" ");
      return { date: datePart || "", time: timePart || "" };
    };

    const mapSlots = (slots) =>
      Array.isArray(slots) && slots.length > 0
        ? [
            slots.map((slot) => ({
              startDate: slot.dateStartAt || "",
              endDate: slot.dateEndAt || "",
              startTime: slot.slotStart || slot.slotStartAt || "",
              endTime: slot.slotEnd || slot.slotEndAt || "",
              quantity: slot.requiredQty?.toString() || "",
              rtcChecked:
                slot.rtcChecked ??
                (slot.slotStart === "00:00" && slot.slotEnd === "24:00"),
            })),
          ]
        : [[]];
    const expiry = splitDateTime(data.expiryAt);
    const termsExpiry = splitDateTime(data.termsExpiryAt);

    console.log("🚀 ~ preparePrefilledData ~ data:", data);
    return {
      id: data.id,
      injectionSlots: mapSlots(data.bankingSlotInjects),
      drawalSlots: mapSlots(
        data.bankingSlotDraws ||
          data.bankingSlotDrawal ||
          data.bankingSlotDrawls,
      ),
      bankingFactor: data.bankingFactor?.toString() || "",
      settlementRate: data.settlementRate || "DAM+",
      comments: data.comments || "",
      expiryDate: expiry.date,
      expiryTime: expiry.time,
      termsExpiryDate: termsExpiry.date,
      termsExpiryTime: termsExpiry.time,
      activeType: data.gnaepleListing || "GNA",
      isInjectionOnTop:
        data.isInjectionOnTop !== undefined ? data.isInjectionOnTop : true,
      termsByPass: data?.termsByPass,
    };
  };

  const getSwappedPrefilledData = (data) => {
    const original = preparePrefilledData(data);
    return {
      ...original,
      injectionSlots: original.drawalSlots,
      drawalSlots: original.injectionSlots,
      isInjectionOnTop: !original.isInjectionOnTop,
    };
  };

  const handleDownload = async (id, name) => {
    const response = await downloadListing(id);
    const blob = response.data;
    if (!blob) return;
    const url = window.URL.createObjectURL(
      new Blob([blob], {
        type: "application/pdf",
      }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `listing_${name}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    SuccessMessage("Listing downloaded successfully!");
  };

  return (
    <>
      <div className={Styles.bankingSearchMainCont}>
        <div className={Styles.bankingSearchHead}>
          <div className={Styles.receivedBackButton} onClick={handleBackClick}>
            {/* Alternative: For guaranteed page refresh, change onClick to:
                onClick={() => window.location.href = '/banking'} */}
            <BackIcon />
            Back
          </div>
          <div className={Styles.receivedHeading}>
            All Available Matching Listing
          </div>
        </div>

        <div className={Styles.indentsMainContainer}>
          <div className={Styles.indentsMainTableSection}>
            <div className={Styles.tableIndentsContent}>
              <div className={Styles.tableIndentsHeaderSection}>
                <div className={Styles.tableIndentHeader}>
                  <div className={Styles.indentsHeading}>Listing Id</div>
                  <div className={Styles.indentsHeading}>Injection/Drawal</div>
                  {/* <div
                    className={`${Styles.indentsHeading} ${Styles.indentHeadQty}`}
                  >
                    Quantity
                  </div> */}
                  <div
                    className={`${Styles.indentsHeading}  ${Styles.indentHeadQty}`}
                  >
                    BF(%)
                  </div>
                  <div className={Styles.indentsHeading}>SR(₹/kWh)</div>
                  <div className={Styles.indentsHeading}>
                    Terms & Conditions
                  </div>
                  <div className={Styles.indentsHeading}>Expires on</div>
                  <div className={Styles.indentsHeading}>Action</div>
                </div>
              </div>
              <div className={`${Styles.searchTableSection} `}>
                {loading ? (
                  Array.from({ length: skeletonRows }).map((_, idx) => (
                    <div key={idx} className={Styles.indentsListTable}>
                      <div
                        className={`${Styles.indentsListHeading} ${Styles.indentName}`}
                      >
                        <Skeleton width={140} height={20} />
                      </div>
                      <div className={Styles.indentsListHeading}>
                        <Skeleton width={100} height={20} />
                      </div>
                      <div
                        className={`${Styles.indentsListHeading} ${Styles.indentQty}`}
                      >
                        <Skeleton width={50} height={20} />
                      </div>
                      <div className={Styles.indentsListHeading}>
                        <Skeleton width={50} height={20} />
                      </div>
                      <div
                        className={`${Styles.indentsListHeading} ${Styles.indentQty}`}
                      >
                        <Skeleton width={50} height={20} />
                      </div>
                      <div className={Styles.indentsListHeading}>
                        <Skeleton width={120} height={20} />
                      </div>
                      <div className={Styles.indentsListHeading}>
                        <Skeleton width={80} height={36} />
                      </div>
                    </div>
                  ))
                ) : allListingsSeacrh && allListingsSeacrh.length > 0 ? (
                  allListingsSeacrh.map((item, index) => (
                    <div
                      key={index}
                      className={Styles.indentsListTable}
                      style={{
                        backgroundColor:
                          highlightedId === item?.id ? "#f3f7fd" : "white",
                        transition: "background-color 0.3s ease",
                      }}
                    >
                      <div
                        className={`${Styles.indentsListHeading} ${Styles.indentName}`}
                        title={item?.name}
                      >
                        {item?.name || "N/A"}
                      </div>

                      <div className={Styles.indentsListHeading}>
                        <div
                          className={Styles.viewSearchBank}
                          onClick={() => handleOpenView(item)}
                        >
                          View Details
                        </div>
                      </div>

                      <div
                        className={`${Styles.indentsListHeading} ${Styles.indentQty}`}
                      >
                        {Number(item?.bankingFactor).toFixed(2) ?? 0}
                      </div>

                      <div className={Styles.indentsListHeading}>
                        {item?.settlementRate ?? 0}
                      </div>

                      <div
                        className={`${Styles.indentsListHeading} ${
                          item?.termsDocumentId && item.termsDocumentId !== 0
                            ? Styles.viewSearchBank
                            : ""
                        }`}
                        onClick={() => {
                          if (
                            item?.termsDocumentId &&
                            item.termsDocumentId !== 0
                          ) {
                            handleViewTermsDocument(item.termsDocumentId);
                          }
                        }}
                        style={{
                          cursor:
                            item?.termsDocumentId && item.termsDocumentId !== 0
                              ? "pointer"
                              : "default",
                          opacity:
                            item?.termsDocumentId && item.termsDocumentId !== 0
                              ? 1
                              : 0.6,
                        }}
                        title={
                          item?.termsDocumentId && item.termsDocumentId !== 0
                            ? "Click to view terms & conditions"
                            : "No terms & conditions available"
                        }
                      >
                        {item?.termsDocumentId && item.termsDocumentId !== 0
                          ? "View T&C"
                          : "No T&C"}
                      </div>

                      <div className={Styles.indentsListHeading}>
                        {item?.expiryAt || "No Expiry"}
                      </div>

                      <div className={Styles.indentsListHeading}>
                        <div
                          className={Styles.connectBankButton}
                          onClick={() => handleOpenConnect(item)}
                          style={{
                            backgroundColor:
                              highlightedId === item?.id ? "#f1935c" : "white",
                            color:
                              highlightedId === item?.id ? "white" : "#f1935c",
                            transition:
                              "background-color 0.3s ease, color 0.3s ease",
                          }}
                        >
                          Connect
                        </div>
                        <span
                          style={{ paddingLeft: "10px", cursor: "pointer" }}
                          onClick={() => handleDownload(item.id, item.name)}
                        >
                          <Download />
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className={Styles.noDataMessage}>
                    <NoDataPage />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {viewDetails && (
        <ViewInjectDrawal
          open={viewDetails}
          handleClose={handleCloseView}
          data={selectedListing}
        />
      )}
      {connect && (
        <ConnectListingModal
          open={connect}
          handleClose={handleCloseConnect}
          heading="Create and Connect Banking Listing"
          // prefilledData={preparePrefilledData(selectedListing)}
          prefilledData={getSwappedPrefilledData(selectedListing)}
          onSubmitSuccess={handleConnectSubmitSuccess}
        />
      )}
      {/* {connect && (
        <BankingListingModal
          open={connect}
          handleClose={handleCloseConnect}
          heading="Create and Connect Banking Listing"
          // prefilledData={preparePrefilledData(selectedListing)}
          prefilledData={getSwappedPrefilledData(selectedListing)}
          onSubmitSuccess={handleConnectSubmitSuccess}
        />
      )} */}
      {previewModal && (
        <PreviewModal
          open={previewModal}
          onClose={handleClosePreview}
          fileUrl={previewFileUrl}
          fileName={previewFileName}
        />
      )}
    </>
  );
};

export default BankingSearch;
